{
	"termsAndConditions": {
		"title": "Termeni și condiții",
		"submitTitle": "Acceptă și continuă către Politica de confidențialitate"
	},
	"privacyPolicy": {
		"title": "Politica de confidențialitate",
		"submitTitle": "Acceptă și închide",
		"backTitle": "Înapoi"
	}
}
